import { Box } from "@mui/material";
import styled from "@mui/system/styled";
import { CsvErrorCell } from "components/CaseManagement/CsvErrors/CsvErrorCell";
import { FC } from "react";

export interface CsvErrorWrapper {
  count: number;
  errors: Record<string, string[]> | null;
  results: CSVErrorResults[];
}

export interface CSVErrorResults {
  row: number;
  columns: CsvError[];
}

export interface CsvError {
  id: number;
  name: string;
  value: string | number;
  errors: string[] | null;
}

interface Props {
  errors: CsvErrorWrapper | null;
}

export const CsvErrorFeedback: FC<Props> = ({ errors }): JSX.Element => {
  return (
    <Container>
      <StyledTable>
        <thead>
          <tr>
            <StyledTh>Row</StyledTh>
            {errors?.results[0].columns.map(column => (
              <StyledTh key={column.id}>{column.name}</StyledTh>
            ))}
          </tr>
        </thead>

        <tbody>
          {errors?.results?.map(row => (
            <tr key={row.row}>
              <StyledTd>{row.row}</StyledTd>
              {row.columns.map(column => (
                <CsvErrorCell key={column.id} {...column} />
              ))}
            </tr>
          ))}
        </tbody>
      </StyledTable>
    </Container>
  );
};

const Container = styled(Box)`
  width: 100%;
  overflow-x: auto;
`;
Container.displayName = "Container";

const StyledTable = styled("table")`
  width: 100%;
  border-collapse: collapse;
`;
StyledTable.displayName = "StyledTable";

const StyledTh = styled("th")`
  text-align: left;
  border: 1px solid #ccc;
  padding: ${props => props.theme.spacing(1)};
  white-space: nowrap;
`;
StyledTh.displayName = "StyledTh";

const StyledTd = styled("td")`
  text-align: left;
  border: 1px solid #ccc;
  padding: ${props => props.theme.spacing(1)};
  white-space: nowrap;
`;
StyledTd.displayName = "StyledTd";
